import { faCircleSmall } from '@fortawesome/pro-solid-svg-icons';
import { IconTag } from '@tryhackme/thm-ui-components';
import { StyledSidePanelFormToggleRow, StyledSidePanelText } from '../../corporate.styles';
import { SidePanelSelfServeRowProps } from '../../corporate.types';
import { StyledCircleIcon } from './self-serve-tag.styles';
import { SelfRenewelConstant, SelfServeConstant } from './self-serve.constants';
export const SidePanelSelfServeRow = ({
  label,
  selfServeBilling,
  selfServeRenewal
}: SidePanelSelfServeRowProps) => {
  const selfServeBillingBool = !!selfServeBilling;
  const selfServeBillingText = selfServeBillingBool ? 'Set up' : 'Not set up';
  const selfServeRenewalText = selfServeBillingBool && !selfServeRenewal ? 'Yes' : 'No';
  return <StyledSidePanelFormToggleRow data-sentry-element="StyledSidePanelFormToggleRow" data-sentry-component="SidePanelSelfServeRow" data-sentry-source-file="self-serve-tag.tsx">
      <StyledSidePanelText data-sentry-element="StyledSidePanelText" data-sentry-source-file="self-serve-tag.tsx">{label}</StyledSidePanelText>
      <IconTag type={label === SelfServeConstant && selfServeBillingBool || label === SelfRenewelConstant && selfServeRenewalText === 'Yes' ? 'success' : 'error'} data-sentry-element="IconTag" data-sentry-source-file="self-serve-tag.tsx">
        <StyledCircleIcon icon={faCircleSmall} $color={label === SelfServeConstant && selfServeBillingBool || label === SelfRenewelConstant && selfServeRenewalText === 'Yes' ? 'success' : 'error'} data-sentry-element="StyledCircleIcon" data-sentry-source-file="self-serve-tag.tsx" />
        {label === SelfServeConstant ? selfServeBillingText : selfServeRenewalText}
      </IconTag>
    </StyledSidePanelFormToggleRow>;
};